
import { handleActions } from 'redux-actions'
import { mediaDevicesChange, mediaDevicesQueryInProgress } from './../actions/media'

const initialState = {
  audioInput: {
    stream: null,
    tracks: null,
    notAllowed: false,
    error: false,
    settings: {},
  },
  constraints: {
    echoCancellation: true,
    autoGainControl: false,
    noiseSuppression: false,
    latency: 0,
    sampleRate: 48000,
    sampleSize: 16,
    volume: 1.0,
    channelCount: 1,
  },
  devices: null,
  queryDuration: 0,
  updated: 0,
  queryInProgress: false,
  listening: false,
}

export const mediaDevicesReducer = handleActions({
  [mediaDevicesChange] (prevState, action) {
    // various payload may arrive to update only
    // state specific fields
    return {
      ...prevState,
      ...action.payload,
    }
  },
  [mediaDevicesQueryInProgress] (prevState, action) {
    return {
      ...prevState,
      queryInProgress: Boolean(action.payload),
    }
  },
}, initialState)
